import { render, staticRenderFns } from "./CollectEidtDialog.vue?vue&type=template&id=3f71b141&scoped=true&"
import script from "./CollectEidtDialog.vue?vue&type=script&lang=js&"
export * from "./CollectEidtDialog.vue?vue&type=script&lang=js&"
import style0 from "./CollectEidtDialog.vue?vue&type=style&index=0&id=3f71b141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f71b141",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f71b141')) {
      api.createRecord('3f71b141', component.options)
    } else {
      api.reload('3f71b141', component.options)
    }
    module.hot.accept("./CollectEidtDialog.vue?vue&type=template&id=3f71b141&scoped=true&", function () {
      api.rerender('3f71b141', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/collect/CollectEidtDialog.vue"
export default component.exports